var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgTextListBulleted = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M6.75 4.313h9M6.75 9h9m-9 4.688h9" }), _jsx("path", { fill: "currentColor", d: "M3.375 5.247a.935.935 0 1 0 0-1.87.935.935 0 0 0 0 1.87m0 4.688a.935.935 0 1 0 0-1.87.935.935 0 0 0 0 1.87m0 4.687a.935.935 0 1 0 0-1.87.935.935 0 0 0 0 1.87" })] }))); };
export default SvgTextListBulleted;
